// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"912b9df5b7f4816e","9998":"24406f722bc597eb"}[chunkId] + ".css";
};